import React from "react"

const SampleScreen = () => <div>Sample screen</div>
export default SampleScreen
